<template>
  <div class="page-wrapper">
    <div class="item" v-for="(item,index) in houseTypeConfigs" :key="'keyA'+index">
      <div class="desc">{{item.itemName}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    name:'HouseTypeConfigInfo',
    props:{
      houseTypeConfigs: {
        type: Array,
        default: []
      }
    },
    components:{
    },
    data(){
      return {
      }
    },
    watch:{
    },
    methods:{
    },
    created(){
    }
  }
</script>
<style scoped>
  .item{
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 10px;
  }
  .head-img{
    display: block;
    width: 260px;
    height: 170px;
    margin-bottom: 5px;
  }
  .name{
    display: block;
    line-height: 2;
    font-weight: bold;
    color: #444444;
  }

</style>
